import React, { FC } from 'react'

import { ChevronLeftIcon, ChevronRightIcon } from '@inno-ui/icons'

import { ControlButton } from '../ControlButton'
import { NavigationControlsProps } from './NavigationControls.types'

export const NavigationControls: FC<NavigationControlsProps> = ({
  isIframe,
  onBack,
  onForward,
  hasBack,
  hasForward
}) => {
  if (!isIframe || (!hasBack && !hasForward)) return null
  return (
    <>
      <ControlButton
        onClick={onBack}
        icon={ChevronLeftIcon}
        disabled={!hasBack}
      />
      <ControlButton
        onClick={onForward}
        icon={ChevronRightIcon}
        disabled={!hasForward}
      />
    </>
  )
}
